import 'video.js'

document.addEventListener('DOMContentLoaded', function() {
    // no-op
});
